import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as taskActions from '../../actions/taskActions';
import selectAllProps from './selectors';
import toastr from 'toastr';

import moment from 'moment';
import MyLoader from '../../components/MyLoader';

import {
    Dialog,
    FlatButton
} from 'material-ui';

import Timeline from '../../components/Timeline';
import TaskList from '../../components/TaskManager/TaskList';

class TimeSheetContainer extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.loading = false;
        this.state = {
            dialogOpened: false,
            selectedTaskToDelete: null,
            currentTimeSheet: props.params.timeSheet,
            selectedTimeSheet: null
        };
    }

    componentWillMount() {
        //console.log('TimeSheetContainer::componentWillMount');
        this.updateSelectedTimeSheet(this.props.timeSheets,this.props.params.timeSheet);
        this.loading = true;
        console.log(this.state.currentTimeSheet);
        this.props.taskActions.getMyTasks(this.state.currentTimeSheet).then(()=>{
            this.loading = false;
        });
    }

    componentWillReceiveProps(nextProps, ownProps) {
        //console.log('TimeSheetContainer::componentWillReceiveProps');
        this.updateSelectedTimeSheet(nextProps.timeSheets,nextProps.params.timeSheet);
    }

    componentWillUpdate(state, ownState) {
        if ((ownState.currentTimeSheet != ownState.selectedTimeSheet.date || this.props.tasks.length==0) && !this.loading) {
            //console.log('TimeSheetContainer::componentWillUpdate',state,ownState,this.props.tasks);
            this.loading = true;
            this.props.taskActions.getMyTasks(state.params.timeSheet).then(()=>{
                this.loading = false;
            });
            this.setState(Object.assign({}, {currentTimeSheet: ownState.selectedTimeSheet.date}));
        }
    }

    updateSelectedTimeSheet(timeSheets,date){
        let selectedTimeSheet = timeSheets.filter((timeSheet) => {
            if (moment(timeSheet.date).isSame(moment(date), "d")) return timeSheet;
        })[0];
        this.setState({selectedTimeSheet: Object.assign({}, selectedTimeSheet)});
    }

    selectDay(day) {
        this.context.router.push('/timeSheet/' + day.date);
    }

    openDialogDeleteTask(task) {
        this.setState({dialogOpened: true, selectedTaskToDelete: task});
    }

    closeDialogDeleteTask() {
        this.setState({dialogOpened: false, selectedTaskToDelete: null});
    }

    deleteTask() {
        this.props.taskActions.deleteTask(this.state.selectedTaskToDelete).then(() => {
            toastr.success('Tache supprimée avec succès','Suppression');
        });
        this.closeDialogDeleteTask();
    }

    render() {
        const onDaySelect = (day) => this.selectDay(day);
        const closeModalDeleteTask = () => this.closeDialogDeleteTask();
        const deleteTask = () => this.deleteTask();
        const modalDeleteTaskActions = [
            <FlatButton
                key="annuler"
                label="Annuler"
                primary
                onTouchTap={closeModalDeleteTask}
            />,
            <FlatButton
                key="supprimer"
                label="Supprimer"
                primary
                onTouchTap={deleteTask}
            />
        ];
        const openDialogDeleteTask = (task) => {
            this.openDialogDeleteTask(task);
        };
        const {tasks} = this.props;
        if (this.props.timeSheets.length == 0 || this.state.selectedTimeSheet == null) return (<MyLoader/>);
        return (
            <div>
                <Timeline {...this.props} selectedTimeSheet={this.state.selectedTimeSheet} onDaySelect={onDaySelect}/>
                {/*<TaskManager selectedTimeSheet={selectedTimeSheet}/>*/}
                <TaskList tasks={tasks} onDeleteTask={openDialogDeleteTask}
                          selectedTimeSheet={this.state.selectedTimeSheet}/>
                <Dialog
                    actions={modalDeleteTaskActions}
                    open={this.state.dialogOpened}
                    contentStyle={{maxWidth: 400}}
                >
                    Voulez-vous vraiment supprimer cette tache?
                </Dialog>
                {this.props.children}
            </div>
        );
    }
}

TimeSheetContainer.contextTypes = {
    router: PropTypes.object
};

TimeSheetContainer.propTypes = {
    taskActions: PropTypes.object,
    timeSheets: PropTypes.array.isRequired,
    children: PropTypes.node,
    tasks: PropTypes.array,
    params: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return selectAllProps(state);
}

function mapDispatchToProps(dispatch) {
    return {
        taskActions: bindActionCreators(taskActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(TimeSheetContainer);


/** WEBPACK FOOTER **
 ** ./src/container/TimeSheetContainer/index.js
 **/